import { types } from './types';

export const setGetPaymentsAction = (payload) => {
  return {
    type: types.SET_GET_PAYMENTS,
    payload,
  }
}

export const setGetPaymentsByIdAction = (payload) => {
  return {
    type: types.SET_GET_PAYMENTS_BY_ID,
    payload
  }
}